import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTheme } from '@material-ui/core/styles';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const InvestmentExpress = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Inversión
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Plan especial
      </Typography>
      <Typography variant="body1" color="textSecondary" align="center" paragraph sx={{ maxWidth: 680, mx: 'auto' }}>
        Estructura pensada para mutuo beneficio: facilita la logística de productos para la sede TNO y mantiene flujo de
        caja cómodo para la operación de medios.
      </Typography>

      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 520, mx: 'auto', borderRadius: 2, mb: 2 }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Inversión mensual total</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                $99
              </TableCell>
            </TableRow>
            <TableRow sx={{ bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50' }}>
              <TableCell>60% en efectivo (cash) — cobertura operativa de plataforma</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                $59.40
              </TableCell>
            </TableRow>
            <TableRow sx={{ bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50' }}>
              <TableCell>
                40% en intercambio (trade) — productos Danimar para mantenimiento de la sede TNO Network
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                $39.60
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentExpress;
